<div class="select-page"><div class="row" [ngClass]="isArabic ? 'arabicAlign' : ''">
  <div class="col-8 asessmentList">
    <form [formGroup]="form">
      <label class="ques p-0" [ngClass]="isArabic ? 'rightAlign' : ''">
        <span *ngIf="!isArabic">Please select an Assessment :</span>
        <span *ngIf="isArabic">: يرجى اختيار تقييم</span>
      </label>
      <div class="ans-pnl">
        <select class="form-select" formControlName="enforcement"
          [ngClass]="isArabic ? 'rightAlign' : ''">
          <option value=""> <!-- Default -->
            <span *ngIf="!isArabic">Select Option</span>
            <span *ngIf="isArabic">اختر خياراً</span>
          </option>
          <option *ngFor="let item of enforcementList" [value]="item.mde_questionaireaccountsid">
            {{ item?.mde_name }}
          </option>
        </select>
      </div>
    </form>
  </div>
</div>
<div class="startBtnDiv" [ngClass]="isArabic ? 'col-md-4' : 'offset-md-8 col-md-4'">
  <button
    type="button"
    (click)="goToDetail()"
    class="btn-lg btn-primary ratButton rightBtn nextButton"
    >   <ng-container>
      <span *ngIf="!isArabic">VIEW ENFORCEMENT</span>
      <span *ngIf="isArabic">عرض الإجراءات التنفيذية</span>
    </ng-container>
  </button>
</div>
</div>
